import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axiosInstance.post("/account/logout"); // 로그아웃 API 호출
      // 쿠키 삭제를 위해 만료시킴
      document.cookie = "isLogined=; path=/; max-age=0";

      // 세션 스토리지 삭제
      // sessionStorage.clear();
      
      // 로컬 스토리지 삭제
      localStorage.clear();

      // navigate('/');
      window.location.reload(); // 또는 navigate('/')로 메인으로 이동
    } catch (error) {
      console.error("로그아웃 실패", error);
    }
  };
  
return (
    <>
    <button
      onClick={handleLogout}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '24px',
        verticalAlign: 'middle',
      }}
      aria-label="로그아웃"
    >
      <span
        className="icon icon-logout"
        style={{
          display: 'inline-block',
          width: '20px',
          height: '20px',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      ></span>
    </button>
    </>
  );
};

export default Logout;